import s from './RefundFlow.module.scss';
import ProfileMenuHeader from '../../ProfileMenuHeader';
import Button from 'components/shared/Button';
const RefundConfirm = ({ onClose, onNext, refundLoading  }) => {
  return (
    <div className={s.refund}>
      <ProfileMenuHeader text="" onClose={onClose} />

      <div>
        <div className={s.confirm_title}>Confirm return</div>
        <div className={s.confirm_subtitle}>
          Are you sure you want to return <br />
          this item?
        </div>
        <div className={s.confirm_description}>
          Please review your selection before proceeding. By confirming, you agree to our return
          policy and terms of service. You will recieve a confirmation email once the return process
          is initiated.
        </div>
      </div>

      <Button style={{ marginTop: 'auto' }} wide darkGreen onClick={onNext} loading={refundLoading}>
        Confirm
      </Button>
    </div>
  );
};

export default RefundConfirm;
